import React, {ReactElement} from 'react';
import dayjs from 'dayjs';

import {Layout} from '@phonectas/unifon-ui-kit';
import {StyledDatePicker} from '../../styled';

interface VismaPostponeProps {
    quickRanges: ReactElement;
    onDateChange: (date: Date | null) => void;
    selectedDate: Date | null;
	customRanges?: {id: string; label: string; to: Date}[];
}

const VismaPostpone: React.FC<VismaPostponeProps> = ({
	quickRanges, 
	onDateChange, 
	selectedDate, 
}): React.JSX.Element => {

	return (
		<Layout fullWidth nowrap>
			{/* <Layout direction="column" style={{width: '100px'}}>
				<Text variant="body1" color="secondary">
					{t('Due date')}
				</Text>
			</Layout> */}
			<Layout direction="column" gap="sm" alignItems="center" fullWidth>
				<Layout alignItems="center">
					<StyledDatePicker
						// compact
						// $disableShadow
						selectsRange
						disablePortal
						customQuickRanges={quickRanges}
						onChange={onDateChange}
						selected={dayjs(selectedDate, 'DDMMYY').toDate()}
						minDate={dayjs().toDate()}
						maxDate={dayjs().add(13, 'day').toDate()}
						inline
					/>
				</Layout>
				{/* <Text variant="body1" color="secondary">
					{t('Max 14 days ahead')}
				</Text> */}
			</Layout>
		</Layout>
	);
}

export default VismaPostpone;